import { Slider as SliderCore, SliderDrag, SliderItem } from '@studiometa/ui';
import SliderBtn from './SliderBtn.js';

/**
 * Slider
 */
export default class Slider extends SliderCore {
  static config = {
    components: {
      SliderBtn,
      SliderDrag,
      SliderItem,
    },
  };

  /**
   * Set isDragging
   */
  onSliderDragStart() {
    this.isDragging = true;
    super.onSliderDragStart();
  }

  /**
   * Check if isDragging before handling drag
   * @param {import('@studiometa/js-toolkit').DragServiceProps} props
   */
  onSliderDragDrop(props) {
    if (this.isDragging) {
      super.onSliderDragDrop(props);
    }

    this.isDragging = false;
  }
}
